import { type TelemetryProperties, trackEvent } from './telemetry';

export const PaymentLinksTelemetryEvents = {
  BannerImpression: 'PaymentLinks.OnboardingBanner.Impression',
  TooltipOpened: 'PaymentLinks.OnboardingBanner.TooltipOpened',
  TooltipDismissed: 'PaymentLinks.OnboardingBanner.TooltipDismissed',
  BannerDismissed: 'PaymentLinks.OnboardingBanner.Dismissed',
  OnboardingLinkSelected: 'PaymentLinks.OnboardingBanner.OnboardingLinkSelected',
  BannerRestored: 'PaymentLinks.OnboardingBanner.Restored',
  NavigationFailed: 'PaymentLinks.OnboardingBanner.NavigationFailed',
  StateResolutionFailed: 'PaymentLinks.OnboardingBanner.StateResolutionFailed',
  DismissalPreferenceUpdated: 'PaymentLinks.OnboardingBanner.DismissalPreferenceUpdated',
  PreferenceUpdateFailed: 'PaymentLinks.OnboardingBanner.PreferenceUpdateFailed',
  /** Authoring-only preview of a template using the payment link token; no link is generated and no email is sent. */
  TemplateAuthoringPreviewed: 'PaymentLinks.TemplateAuthoring.Previewed',
} as const;

export interface PaymentLinksTelemetryContext {
  organisationId?: string;
  companyId?: string;
  role?: string;
  onboardingState?: string;
}

/**
 * Emits a Payment Links onboarding event with the tenant, role and onboarding state attached.
 * Callers must only pass identifiers, states and flags — never credentials or payment data.
 */
export function trackPaymentLinksEvent(
  name: string,
  context: PaymentLinksTelemetryContext,
  properties?: TelemetryProperties,
): void {
  // Application Insights serializes an undefined property as the literal string "undefined", so absent
  // context is dropped instead of reported.
  const attributes: TelemetryProperties = { ...context, ...properties, timestamp: new Date().toISOString() };

  for (const [key, value] of Object.entries(attributes)) {
    if (value === undefined) {
      delete attributes[key];
    }
  }

  trackEvent(name, attributes);
}

export function newCorrelationId(): string {
  return typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `pl-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
